import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';

interface InvoicesState {
  isInitialized: boolean;
  pastInvoices: dashboard.Invoice[];
}

const initialState: InvoicesState = {
  isInitialized: false,
  pastInvoices: [],
};

export default function reducer(state = initialState, action: BaseTockAction): InvoicesState {
  const { type, payload } = action;
  switch (type) {
    case AppConstants.INVOICE_FETCH_ALL_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case AppConstants.INVOICE_FETCH_ALL_DONE: {
      return {
        isInitialized: true,
        pastInvoices: payload,
      };
    }
    case AppConstants.INVOICE_FETCH_ALL_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    default:
      return state;
  }
}
